import React, { useRef, forwardRef, useImperativeHandle, useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import cuponicon from "../../assets/images/cupon-icon.png";
import { Link } from "react-router-dom";
import { filterExpiredCoupons } from "../../utils/couponUtils";

const CuponSlide = forwardRef(function CuponSlide({ restOffer }, ref) {
  const sliderRef = useRef(null);

  // Filter expired coupons
  const validOffers = useMemo(() => filterExpiredCoupons(restOffer || []), [restOffer]);

  const settings = {
    dots: false,
    infinite: validOffers?.length > 1 ? true : false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false, // external arrows handled by parent
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  useImperativeHandle(ref, () => ({
    next: () => sliderRef.current && sliderRef.current.slickNext(),
    prev: () => sliderRef.current && sliderRef.current.slickPrev(),
  }));

  return (
    <div className="deals-slider">
      <Slider ref={sliderRef} {...settings}>
        {validOffers?.length > 0 ? (
          validOffers?.map((coupon) => {
            return (
              <div key={coupon.id} className="cupon-card col-12 d-flex align-items-center">
                <Link className="d-flex align-items-center justify-content-between w-100">
                  <div className="col-2 p-0">
                    <img src={cuponicon} alt="cuponicon" />
                  </div>
                  <p className="col-6 mb-0">
                    <span className="text-danger">{coupon.coupon_title}</span>{" "}
                    <br />
                    <span className="coupon_sub_title">{coupon.coupon_sub_title}</span>
                  </p>
                  <div className="col-4 text-center">
                    <span className="badges success mb-1">{coupon.coupon_code}</span>
                  </div>
                </Link>
              </div>
            );
          })
        ) : (
          <p className="text-center text-danger h5">No Offer Available</p>
        )}
      </Slider>
    </div>
  );
});

export default CuponSlide;
